<template>
  <div class="cabecalho-tabela">
    <h4 v-if="!semTitulo" class="header-title m-b-10">{{ titulo }}</h4>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 p-t-10">
        <small>
          {{ totalRegistrosText }}:
          <span
            class="badge badge-secondary p-t-5 p-b-5 cabecalho-total-encontrado"
            >{{ totalRegistros }}</span
          >
        </small>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HcCabecalhoTabela",
  props: {
    titulo: {
      type: String,
      default: "Resultado"
    },
    totalRegistrosText: {
      type: String,
      default: "Total de registros encontrados"
    },
    totalRegistros: {
      type: Number,
      default: 0
    },
    semTitulo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
